import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getGroupById } from "../api/group";
import logo from "../assets/onconext.png";
import fondoMarcador from "../assets/bg/fondo-marcador.png";
import { useTimer } from "../hooks/useTimer";
import { updateTime } from "../redux/actions";
import { GAME_TIME_SECS, ROUTES } from "../utils/constants";
import {
	formatMinutes,
	formatSeconds,
	getTimer,
	updateStats,
	updateTimer,
	setLastTickNow,
	getLastTick,
	setLastTick 
} from "../utils/helpers";
import { modalIntro, modalText } from "../utils/logger";

export default function TopBar() {
	const timeout = GAME_TIME_SECS;
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const game = useSelector((state) => state.game);
	const [group, setGroup] = useState(useSelector((state) => state.group));
	//const [time, setTime] = useState(parseInt(group?.time));
	//let isACTIVE = false;
	const [score, setScore] = useState(group?.score || 0);

	const [time, setTime] = useState(() => {
		const saved = getTimer();
		const n = saved !== null ? Number(saved) : parseInt(group?.time || 0, 10);
		return Number.isFinite(n) ? n : 0;
	});

	/*
	useTimer(() => {
		if (!isACTIVE && getTimer()) isACTIVE = true;
		if (isACTIVE) handleTimer();
	}, 1000);
	*/
	useTimer(() => {
		handleTimer();
	}, 1000);

	/*
	const handleTimer = () => {
		if (!getTimer()) isACTIVE = false;
		else {
			setTime(time + 1);
			updateTimer(time);
		}
	};
	*/

	useEffect(() => {
	  if (getTimer() !== null && !getLastTick()) setLastTickNow();
	}, []);

	const handleTimer = () => {
		// Si no hay contador, no corremos
		if (getTimer() === null) return;
		const now = Date.now();
		const prevTick = getLastTick() ?? now;
		const deltaMs  = now - prevTick;
		const deltaSec = Math.floor(deltaMs / 1000);
		if (deltaSec <= 0) return;
		setTime((prev) => {
			const next = prev + deltaSec;
			updateTimer(next);
			setLastTick(prevTick + deltaSec * 1000);
			return next;
		});
	};

	useEffect(() => {
		const onVis = () => {
			if (document.visibilityState === "visible") {
			handleTimer(); // actualiza de golpe lo pasado en 2º plano
			}
		};
		document.addEventListener("visibilitychange", onVis);
		return () => document.removeEventListener("visibilitychange", onVis);
	}, []);

	useEffect(() => {
		if (
			time >= timeout &&
			group.lastVisited !== ROUTES.GAMEOVER &&
			!game?.demo
		) {
			dispatch(updateTime(time));
			updateStats({
				...group,
				time: time,
				lastVisited: ROUTES.GAMEOVER,
				finished: true,
			});
			navigate(ROUTES.GAMEOVER);
		} else if (group?.finished) {
			navigate(group?.lastVisited || ROUTES.RESULTS);
		}
	}, [time, group, game, navigate, dispatch]);

	useEffect(() => {
		if (group) {
			getGroupById(group?._id)
				.then((res) => {
					if (res.status === 200) {
						let group = res.data;
						let score = group?.score;
						setScore(score);
					}
				})
				.catch((error) => {});
		}
	}, [location]);

	const REFERENCIAS = `
	<div class="w-100 px-4" style="text-align: left;">
		<h3 class="black bold mb-4">
			REFERENCIAS BIBLIOGRÁFICAS
		</h3>
		<div class="txtTexto1 black">
			<ul>
				<li>Armstrong AJ, Szmulewitz RZ, Petrylak DP, et al. ARCHES: A Randomized, Phase III Study of Androgen Deprivation Therapy With Enzalutamide or Placebo in Men With Metastatic Hormone-Sensitive Prostate Cancer. J Clin Oncol. 2019 Nov 10;37(32):2974-86. https://doi.org/10.1200/JCO.19.00799.</li>
				<li>Attard G, Agarwal N, Graff JN, et al. Niraparib and abiraterone acetate plus prednisone for HRR-deficient metastatic castration-sensitive prostate cancer: a randomized phase 3 trial. Nat Med. 2025 Dec;31(12):4109-18. https://doi.org/10.1038/s41591-025-03961-8.</li>
				<li>Barbato F, Fendler WP, Rauscher I, et al. PSMA-PET for the assessment of metastatic hormone-sensitive prostate cancer volume of disease. J Nucl Med. 2021 May 14;62(12):1747-50. https://doi.org/10.2967/jnumed.121.262120.</li>
				<li>Chi KN, Agarwal N, Bjartell A, et al.; TITAN Investigators. Apalutamide for Metastatic, Castration-Sensitive Prostate Cancer. N Engl J Med. 2019 Jul 4;381(1):13-24. https://doi.org/10.1056/NEJMoa1903307.</li>
				<li>Chi KN, Chowdhury S, Bjartell A, et al. Apalutamide in Patients With Metastatic Castration-Sensitive Prostate Cancer: Final Survival Analysis of the Randomized, Double-Blind, Phase III TITAN Study. J Clin Oncol. 2021 Jul 10;39(20):2294-303. https://doi.org/10.1200/JCO.20.03488.</li>
				<li>Fizazi K, Foulon S, Carles J, et al.; PEACE-1 investigators. Abiraterone plus prednisone added to androgen deprivation therapy and docetaxel in <i>de novo</i> metastatic castration-sensitive prostate cancer (PEACE-1): a multicentre, open-label, randomised, phase 3 study with a 2 × 2 factorial design. Lancet. 2022 Apr 30;399(10336):1695-707. https://doi.org/10.1056/NEJMoa1704174.</li>
				<li>Fizazi K, Foulon S, Carles J, et al.; PEACE-1 investigators. Abiraterone plus prednisone added to androgen deprivation therapy and docetaxel in <i>de novo</i> metastatic castration-sensitive prostate cancer (PEACE-1): a multicentre, open-label, randomised, phase 3 study with a 2 × 2 factorial design. Lancet. 2022 Apr 30;399(10336):1695-707. https://doi.org/10.1016/S0140-6736(22)00367-1.</li>
				<li>Francini E, Gray KP, Xie W, et al. Time of metastatic disease presentation and volume of disease are prognostic for metastatic hormone sensitive prostate cancer (mHSPC). Prostate. 2018 Sep;78(12):889-95. https://doi.org/10.1002/pros.23645.</li>
				<li>Hofman MS, Lawrentschuk N, Francis RJ, et al.; proPSMA Study Group Collaborators. Prostate-specific membrane antigen PET-CT in patients with high-risk prostate cancer before curative-intent surgery or radiotherapy (proPSMA): a prospective, randomised, multicentre study. Lancet. 2020 Apr 11;395(10231):1208-16. https://doi.org/10.1016/S0140-6736(20)30314-7.</li>
				<li>Hussain M, Tombal B, Saad F, et al. Darolutamide Plus Androgen-Deprivation Therapy and Docetaxel in Metastatic Hormone-Sensitive Prostate Cancer by Disease Volume and Risk Subgroups in the Phase III ARASENS Trial. J Clin Oncol. 2023 Jul 10;41(20):3595-607. https://doi-org.pbidi.unam.mx:2443/10.1200/JCO.23.00041.</li>
				<li>Merseburger AS, Agarwal N, Bhaumik A, et al. Apalutamide plus androgen deprivation therapy in clinical subgroups of patients with metastatic castration-sensitive prostate cancer: A subgroup analysis of the randomised clinical TITAN study. Eur J Cancer. 2023 Nov;193:113290. https://doi-org.pbidi.unam.mx:2443/10.1016/j.ejca.2023.113290.</li>
				<li>Rodriguez-Vida A, et al. P124: Apalutamide for metastatic castration-sensitive prostate cancer: Outcomes in patients with more than 10 bone metastases from the titan final analysis [resumen de sesión de póster]. EMUC24 - 16th European Multidisciplinary Congress on Urological Cancers, Lisboa, Portugal. https://urosource.uroweb.org/resource-centres/EMUC24/261000/abstract.</li>
				<li>Saad F, Vjaters E, Shore N, et al.; ARANOTE Study Investigators. Darolutamide in Combination With Androgen-Deprivation Therapy in Patients With Metastatic Hormone-Sensitive Prostate Cancer From the Phase III ARANOTE Trial. J Clin Oncol. 2024 Dec 20;42(36):4271-81. https://doi-org.pbidi.unam.mx:2443/10.1200/JCO-24-01798.</li>
				<li>Smith MR, Hussain M, Saad F, et al.; ARASENS Trial Investigators. Darolutamide and Survival in Metastatic, Hormone-Sensitive Prostate Cancer. N Engl J Med. 2022 Mar 24;386(12):1132-42. https://doi-org.pbidi.unam.mx:2443/10.1056/NEJMoa2119115.</li>
				<li>Sweeney CJ, Chen YH, Carducci M, et al. Chemohormonal Therapy in Metastatic Hormone-Sensitive Prostate Cancer. N Engl J Med. 2015 Aug 20;373(8):737-46. https://doi.org/10.1056/NEJMoa1503747.</li>
				<li>Sweeney CJ, Martin AJ, Stockler MR, et al.; ENZAMET trial investigators and Australian and New Zealand Urogenital and Prostate Cancer Trials Group. Testosterone suppression plus enzalutamide versus testosterone suppression plus standard antiandrogen therapy for metastatic hormone-sensitive prostate cancer (ENZAMET): an international, open-label, randomised, phase 3 trial. Lancet Oncol. 2023 Apr;24(4):323-34. https://doi.org/10.1016/S1470-2045(23)00063-3.</li>
				<li>Vale CL, Fisher DJ, Godolphin PJ, et al.; STOPCAP Collaboration. Which patients with metastatic hormone-sensitive prostate cancer benefit from docetaxel: a systematic review and meta-analysis of individual participant data from randomised trials. Lancet Oncol. 2023 Jul;24(7):783-97. https://doi.org/10.1016/S1470-2045(23)00230-9.</li>
			</ul>
		</div>
	</div>
	`;

	return (
		<div className="py-2" style={{ overflow: "visible" }}>
		<div className="row d-flex justify-content-between align-items-center legalGebro px-4" style={{ overflow: "visible", minHeight: "56px" }}>
			{/* Logo */}
			<div className="col-5 d-flex justify-content-start align-items-center txtTexto2 txtRed">
				<img
					src={logo}
					alt="decorativo"
					style={{
						maxWidth: "130px",
						marginRight: "20px",
						marginTop: "10px"
					}}
				/>
				<span>{group?.fullName || "NOMBRE DEL EQUIPO"}</span>
				<span
					className="px-1 ms-3 rounded"
					style={{
						border: "1px #EB1700 dashed",
						borderRadius: "12px",
						minWidth: "60px",
						fontSize: "16px",
						fontWeight: "bold",
						color: "#EB1700",
						height: "fit-content"
					}}
				>Equipo nº{group?.tableNum || 0}
				</span>
			</div>

			{/* Marcador de puntos: fondo alto que se sobrepone por debajo de la barra */}
			<div className="col-2 d-flex align-items-center justify-content-center" style={{ overflow: "visible", position: "relative", zIndex: 1000, minHeight: "56px" }}>
				<div
					className="d-flex align-items-center justify-content-center px-4"
					style={{
						backgroundImage: `url(${fondoMarcador})`,
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center",
						backgroundSize: "contain",
						minWidth: "90px",
						minHeight: "90px",
						position: "absolute",
						bottom: 0,
						left: "50%",
						transform: "translateX(-50%) translateY(24%)",
					}}
				>
					<div className="txt22 bold" style={{ color: "black" }}>
						{score}
					</div>
				</div>
			</div>

			{/* Derecha: icono i, Bibliografía, timer; barra de tiempo debajo solo desde "i" hasta el contador */}
			<div className="col-5 d-flex flex-column align-items-end">
				<div className="d-inline-flex flex-column align-items-stretch">
					<div className="d-flex align-items-center flex-nowrap">
						<button
							type="button"
							className="topBar-headerIcon topBar-headerIcon--sm"
							onClick={() => modalIntro()}
							title="Instrucciones"
							aria-label="Instrucciones"
						>
							i
						</button>
						<button
							type="button"
							className="topBar-headerBtn topBar-headerBtn--sm"
							onClick={() => modalText({ html: REFERENCIAS })}
						>
							Bibliografía
						</button>
						<div className="d-flex align-items-center topBar-timerWrap">
							<div className="timer timer--sm">
								{formatMinutes(time, timeout, group?.finished)}
							</div>
							<span className="topBar-timerColon blink">:</span>
							<div className="timer timer--sm">
								{formatSeconds(time, timeout, group?.finished)}
							</div>
						</div>
					</div>
					<div className="time-progress-bar mt-2">
						<div
							className="time-progress-fill"
							style={{
								width: `${Math.min(100, (time / timeout) * 100)}%`,
							}}
						/>
						<div
							className="time-progress-handle"
							style={{
								left: `${Math.min(100, (time / timeout) * 100)}%`,
							}}
							aria-hidden
						/>
					</div>
				</div>
			</div>
		</div>
		</div>
	);

}
